import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import sportstep from '../assets/svg/projects/E-commerce.gif'

import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'

import bedrift from '../assets/svg/projects/Bedrifts-Assistanse.gif'
import odal from '../assets/svg/projects/Odal.gif'
import odinala from '../assets/svg/projects/odinala-network.gif'
import prosilk from '../assets/svg/projects/ProSilk.gif'
import Vatogun from '../assets/svg/projects/Vatogun.gif'
import Tiptop from '../assets/svg/projects/TipTop.gif'
import furniture from '../assets/svg/projects/furniture.gif'


export const projectsData = [
    {
        id: 1,
        projectName: 'StoreIgniter',
        projectDesc: 'StoreIgniter is a powerful e-commerce platform built with CodeIgniter and AngularJS. It provides a complete solution for creating and managing online stores with ease. StoreIgniter empowers you to build robust and scalable e-commerce applications.',
        tags: ['HTML', 'Css', 'JavaScript', 'JSon', 'PHP', 'Bootstrap', 'Codeigniter-4', 'AngularJs', 'Stripe','etc'],
        code: 'https://github.com/CoderAnnu/StoreIgniter',
        demo: 'https://github.com/CoderAnnu/StoreIgniter',
        image: four
    },
    {
        id: 2,
        projectName: 'Telegram Bot ( INDIA )',
        projectDesc: 'This project aims to build a Telegram Bot and Telegram Channel management system that consolidates all information of a Bot.',
        tags: ['HTML', 'Css', 'JavaScript', 'JSon', 'PHP', 'Telegram API', 'Bootstrap', 'Codeigniter-4', 'AngularJs', 'Stripe'],
        code: 'https://telegrambot.io/',
        demo: 'https://telegrambot.io/',
        image: one
    },
    {
        id: 3,
        projectName: 'QR Scanner App',
        projectDesc: 'a QR scanner app that uses cutting-edge technology to provide users with a seamless experience.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'AngularJs', 'JSon', 'Codeigniter-4', 'WebRTC technology', 'Stripe', 'Custom Plugins', 'Custom fields', 'Wordpress'],
        code: 'https://qrapp.steigenberg.in/',
        demo: 'https://qrapp.steigenberg.in/',
        image: two
    },
    {
        id: 4,
        projectName: 'Cpanel Management System',
        projectDesc: 'Bedrift Assistance is in the best auto care products & automotive care supplies products',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'AngularJs', 'Custom Plugins', 'Custom fields', 'Wordpress'],
        code: 'https://cpanels.steigenberg.com/',
        demo: 'https://cpanels.steigenberg.com/',
        image: two
    },
    {
        id: 5,
        projectName: 'Bedrift Assistanse | ( NORWAY )',
        projectDesc: 'Bedrift Assistance is in the best auto care products & automotive care supplies products',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'AngularJs', 'Custom Plugins', 'Custom fields', 'Wordpress'],
        code: 'https://codeium.dev/bedriftsassistanse/',
        demo: 'http://www.bedrifts-assistanse.no/',
        image: bedrift
    },

    {
        id: 6,
        projectName: 'SportStep | Sports Shoes outlet',
        projectDesc: 'Sport-Step, the ultimate destination for sports enthusiasts and fitness aficionados. With our custom WordPress site, ',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'Custom fields', 'Wordpress'],
        code: 'https://github.com/CoderAnnu/sports-step',
        demo: 'https://github.com/CoderAnnu/sports-step',
        image: sportstep
    },
    {
        id: 7,
        projectName: 'Odinala Network | ( Nigeria )',
        projectDesc: 'Odinala Network is an African Real Estate marketplace through our fully compliant platform whether pursuing independent, fractional or tokenized ownership. Website with Blockchain technology.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Blockchain', 'Bootstrap', 'Elementor', 'Custom Plugins', 'Wordpress'],
        code: 'https://www.odinala.io/',
        demo: 'https://www.odinala.io/',
        image: odinala
    },
    {
        id: 8,
        projectName: 'Weather App',
        projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
        tags: ['Django', 'CSS', 'Material Ui'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: three
    },

    {
        id: 9,
        projectName: 'Odal | ( NORWAY )',
        projectDesc: 'An E-commerce website of workwear outlet Products. which is developed in wordpress custom theme with Elementor.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'Elementor', 'Custom Plugins', 'Custom fields', 'Wordpress'],
        code: 'https://odal.codeium.dev/',
        demo: 'https://www.xn--arbeidsklroutlet-2ob.no/',
        image: odal
    },
    {
        id: 10,
        projectName: 'Prosilk | ( NORWAY )',
        projectDesc: 'Prosilk is a E-commerce website of Skincare Products. Prosilk is a new age skincare brand with products such as Serum, Moisturizer and skincare products.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'Elementor', 'Custom Plugins', 'Custom fields', 'Wordpress'],
        code: 'https://codeium.dev/prosilk/',
        demo: 'https://codeium.dev/prosilk/',
        image: prosilk
    },

    {
        id: 11,
        projectName: 'Vatogun | ( NORWAY )',
        projectDesc: 'An E-commerce Website of Massage guns Products. which is developed in wordpress custom theme with Elementor.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'Elementor', 'Custom Plugins', 'Wordpress'],
        code: 'https://codeium.dev/vatogun/',
        demo: 'https://codeium.dev/vatogun/',
        image: Vatogun
    },
    {
        id: 12,
        projectName: 'TipTop | ( NORWAY )',
        projectDesc: 'An E-commerce website of Skincare Products. which is developed in wordpress custom theme with Elementor.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Bootstrap', 'Elementor', 'Custom Plugins', 'Wordpress'],
        code: 'https://codeium.dev/tiptop/',
        demo: 'https://www.xn--tiptoprnes-5cb.no/',
        image: Tiptop
    },
    {
        id: 13,
        projectName: 'Furniture Site',
        projectDesc: 'i have developed simple furniture website without e-commerce, this Website display products and admin can update product features and there image etc. through the wordpress admin panel, user friendly website is designed to display products.',
        tags: ['HTML', 'Css', 'JavaScript', 'PHP', 'Custom fields', 'Wordpress'],
        code: 'https://github.com/CoderAnnu/furniture-site',
        demo: 'https://github.com/CoderAnnu/furniture-site',
        image: furniture
    },

]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/


